import { TextField, styled } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';

export const LayoutHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: 20,
});

export const SearchWrapper = styled('div')({
  position: 'relative',
  width: 340,
  flexShrink: 0,
});

export const SearchInput = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 100,
    border: `1px solid ${theme.palette.border}`,
    backgroundColor: theme.palette.common.white,
    fontSize: 14,
  },
  '& .MuiOutlinedInput-input': {
    padding: '10px 12px',
  },
}));

export const ClearButton = styled(ClearIcon)(({ theme }) => ({
  cursor: 'pointer',
  fontSize: 18,
  color: theme.palette.text.secondary,
  '&:hover': { color: theme.palette.text.primary },
}));
